@if (tags().length) {
  <ng-template #contentRef>
    <svg class="__icon" viewBox="0 0 44 52" aria-hidden="true">
      <path
        d="M0.46,27.54 V11 A4,4 0 0 1 3,7.27 L20.19,0.7 A4,4 0 0 1 23,0.7 L40.2,7.27 A4,4 0 0 1 42.74,11 V17.99 L34.84,22.54 V13.71 L21.6,8.62 L8.36,13.7 V23 Z"
        fill="#45a29a"
      />
      <path
        d="M42.74,23.7 V40.41 A4,4 0 0 1 40.2,44.1 L23,50.67 A4,4 0 0 1 20.19,50.67 L3,44.1 A4,4 0 0 1 0.46,40.41 V33.26 L8.5,28.62 V37.74 L21.6,42.75 L34.84,37.69 V28.26 Z"
        fill="#45a29a"
      />
      <rect x="12.332" y="19.06" width="5.296" height="10.592" rx="2.648" fill="currentColor" />
      <rect x="25.572" y="19.06" width="5.296" height="10.592" rx="2.648" fill="currentColor" />
    </svg>
    <span>Mate</span>
  </ng-template>

  @if (groupHref(); as href) {
    <a
      class="__chip __chip--link"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open in Zerops Mate"
      [href]="href">
      <ng-container [ngTemplateOutlet]="contentRef" />
    </a>
  } @else {
    <span class="__chip">
      <ng-container [ngTemplateOutlet]="contentRef" />
    </span>
  }
}
